/* unplugin-vue-components disabled */import { render } from "./beta.vue?vue&type=template&id=555a5570"
import script from "./beta.vue?vue&type=script&lang=js"
export * from "./beta.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/settings/admin/beta.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "555a5570"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('555a5570', __exports__)) {
    api.reload('555a5570', __exports__)
  }
  
  module.hot.accept("./beta.vue?vue&type=template&id=555a5570", () => {
    api.rerender('555a5570', render)
  })

}


export default __exports__